/* rpa.js */

"use strict";

module.exports = {
    name: "rpa",
    label: "Network RPA",
    title: "Network RPA",
    disabled: false,
    order: 13, // Deprecated -- Newer solution uses order from index.js
    app: "GameConsole",
    section: "frontend",
    license: ["GLUWARE", "RPA"],
    accessPerm: ["rpaWorkflowAccess"],
    pageTitle: "Rpa",
    helpLink: "Network%20RPA/RPA-overview.htm",
    iconName: "rpa.solution",
    navIcon: "rpa.solution",
    navOptions: {
        workflowLibrary: {
            name: "Workflow Library",
            options: {
                ra: "library",
            },
            type: "exp",
        },
        workflowActivity: {
            name: "Workflow Activity",
            options: {
                ra: "activity",
            },
            type: "exp",
        },
        workflowPlayground: {
            name: "Template Builder",
            options: {
                ra: "builder/templates",
            },
            type: "exp",
        },
    },
};
